import type { Hub } from "@portal/api/types";

export function selectDefaultHub(hubs: Hub[]) {
  return hubs[0] || null;
}
